export interface AccountassetsFetchInterface {
  searchValue?: string;
}

export const pathFileTypes = {
  dealerphoto: "jpg",
  companylogo: "png"
} as const;

export const fileMimeType = (fileType: string): string => {
  if (fileType === "jpg") {
    return "image/jpeg";
  }
  return `image/${fileType}`;
};
